<template>
  <div>
    <Header :title="title" :showBack="true"></Header>

    <div class="RefundTicket">
      <div class="header">信息输入</div>
      <van-tabs v-bind:swipeable="true" color="#FFB870" v-model="active">
        <van-tab class="checkCar" title="刷卡查询">
          <p>正在获取乘客的购票记录......</p>
          <p>将旅客证件放在设备上获取购票记录</p>
          <p>请放置证件</p>
        </van-tab>
        <van-tab class="handle" title="手动查询">
          <div class="wrap">
            <label>
              <span>开始条码：</span>
              <input v-model="startBarCode" type="number" />
            </label>
            <label>
              <span>张数：</span>
              <input v-model="searchTicketNum" type="number" />
              <div @click="searchTicketNum++" class="add">+</div>
              <div @click="searchTicketNum--" class="reduce">-</div>
            </label>
            <label class="endBarCode">
              <span>截止条码：</span>
              <input v-model="endBarCode" disabled type="text" />
            </label>
            <label class="IdCardNum">
              <span>身份证号码：</span>
              <input v-model="IdCardNum" type="text" autocomplete="off" />
            </label>
            <div class="btn">
              <div @click="searchTicket" class="search">查询</div>
              <div @click="resetBtnClick" class="reset">重置</div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
      <div class="wrap">
        <div class="header">选票信息</div>
        <label>
          <span>票数：</span>
          <input disabled v-model="selectedTicketNum" type="text" />
        </label>
        <label>
          <span>实付金额汇总：</span>
          <input disabled v-model="allPayPrice" type="text" />
        </label>
        <label>
          <span>手续比例汇总：</span>
          <input disabled v-model="allRatio" type="text" />
        </label>
        <label>
          <span>手续费汇总：</span>
          <input disabled v-model="allFee" type="text" />
        </label>
        <label>
          <span>应退金额：</span>
          <input disabled v-model="allBackMoney" type="text" />
        </label>
        <button
          v-if="screenArr.length > 0"
          @click="backTicketBtnClick"
          class="backTicketBtn"
        >
          退 票 设 置
        </button>
      </div>
      <div class="header" id="searchResultHeader">查询结果</div>
      <div
        v-if="resultTicketArr.length > 0 ? true : false"
        class="searchResult"
      >
        <div
          @click="searchResultClick(item, index)"
          v-for="(item, index) of resultTicketArr"
          :key="item.id"
          class="wrap"
          :class="{ searchResultCurrent: item.isSelected == true }"
        >
          <div class="ticketDetails">
            <span>班次日期：</span>
            <span>{{ item.ClassDate }}</span>
          </div>
          <div class="ticketDetails">
            <span>班次时间：</span>
            <span>{{ item.ClassTime }}</span>
          </div>
          <div class="ticketDetails">
            <span>条码：</span>
            <span>{{ item.BarCode }}</span>
          </div>
          <div class="ticketDetails">
            <span>车票状态：</span>
            <span>{{ item.TicketStatusName }}</span>
          </div>
          <div class="searchDetails">
            <span @click.stop="searchDetailsBtnClick(item, index)">
              查看详情
              <span class="iconfont icon">&#xe652;</span>
            </span>
          </div>
        </div>
      </div>
      <div class="notData" v-else>暂无数据</div>

      <div>
        <van-popup
          v-model="TicketDetailsShow"
          position="center"
          :overlay="true"
          class="TicketDetailsShow"
        >
          <div>
            <div>
              <span class="left">订单代码：</span>
              <span class="right">{{ selectedTicketDetailsArr.OrderNo }}</span>
            </div>
            <div>
              <span class="left">线路名称：</span>
              <span class="right">{{ selectedTicketDetailsArr.LineName }}</span>
            </div>
            <div>
              <span class="left">班次日期：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ClassDate
              }}</span>
            </div>
            <div>
              <span class="left">班次时间：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ClassTime
              }}</span>
            </div>
            <div>
              <span class="left">上车点名称：</span>
              <span class="right">{{
                selectedTicketDetailsArr.StartNodeName
              }}</span>
            </div>
            <div>
              <span class="left">下车点名称：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ArrivalNodeName
              }}</span>
            </div>
            <div>
              <span class="left">座位号：</span>
              <span class="right">{{ selectedTicketDetailsArr.SeatNo }}</span>
            </div>
            <div>
              <span class="left">票型：</span>
              <span class="right">{{
                selectedTicketDetailsArr.TicketTypeID
              }}</span>
            </div>
            <div>
              <span class="left">票价：</span>
              <span class="right">{{
                selectedTicketDetailsArr.TicketPrice
              }}</span>
            </div>
            <div>
              <span class="left">车票状态：</span>
              <span class="right">{{
                selectedTicketDetailsArr.TicketStatusName
              }}</span>
            </div>
            <div>
              <span class="left">实付金额：</span>
              <span class="right">{{ selectedTicketDetailsArr.PayPrice }}</span>
            </div>
            <div>
              <span class="left">乘车人姓名：</span>
              <span class="right">{{ selectedTicketDetailsArr.CustName }}</span>
            </div>
            <div>
              <span class="left">乘车人证件类型：</span>
              <span class="right">{{
                selectedTicketDetailsArr.CustCertType
              }}</span>
            </div>
            <div>
              <span class="left">乘车人证件号码：</span>
              <span class="right">{{
                selectedTicketDetailsArr.CustCertNo
              }}</span>
            </div>
            <div>
              <span class="left">乘车人电话：</span>
              <span class="right">{{ selectedTicketDetailsArr.CustTel }}</span>
            </div>
            <div>
              <span class="left">是否包含儿童：</span>
              <span class="right">{{
                selectedTicketDetailsArr.IsChild == true ? "是" : "否"
              }}</span>
            </div>
            <div>
              <span class="left">儿童姓名：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ChildName
              }}</span>
            </div>
            <div>
              <span class="left">儿童证件类型：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ChildCertType
              }}</span>
            </div>
            <div>
              <span class="left">儿童证件号码：</span>
              <span class="right">{{
                selectedTicketDetailsArr.ChildCertNo
              }}</span>
            </div>
            <div>
              <span class="left">条码：</span>
              <span class="right">{{ selectedTicketDetailsArr.BarCode }}</span>
            </div>
            <div>
              <span class="left">备注：</span>
              <span class="right"></span>
            </div>
            <div>
              <span class="left">修改人代码：</span>
              <span class="right"></span>
            </div>
            <div>
              <span class="left">修改人姓名：</span>
              <span class="right"></span>
            </div>
            <div>
              <span class="left">修改时间：</span>
              <span class="right"></span>
            </div>
            <div>
              <span class="left">创建人代码：</span>
              <span class="right">{{
                selectedTicketDetailsArr.CreateCode
              }}</span>
            </div>
            <div>
              <span class="left">创建人姓名：</span>
              <span class="right">{{
                selectedTicketDetailsArr.CreateName
              }}</span>
            </div>
            <div>
              <span class="left">创建时间：</span>
              <span class="right"></span>
            </div>
          </div>
        </van-popup>
      </div>
      <van-popup
        v-model="BackTicketShow"
        position="center"
        :overlay="true"
        class="BackTicketShow"
      >
        <div class="header">退票详情</div>
        <div class="container">
          <div>
            <div class="left">车票总价：</div>
            <div class="right">
              <input v-model="selectedTicketAllPrice" disabled type="text" />
            </div>
          </div>
          <div>
            <div class="left">车票数量：</div>
            <div class="right">
              <input v-model="selectedTicketAllNum" disabled type="text" />
            </div>
          </div>
          <div>
            <div class="left">退票费率：</div>
            <div class="right">
              <input
                @keyup="keyupChangeTicketRatio"
                v-model="selectedTicketAllRatio"
                type="number"
              />
            </div>
          </div>
          <div>
            <div class="left">手续费：</div>
            <div class="right">
              <input v-model="selectedTicketAllFee" disabled type="text" />
            </div>
          </div>
          <div>
            <div class="left">应退金额：</div>
            <div class="right">
              <input
                v-model="selectedTicketAllBackMoney"
                disabled
                type="text"
              />
            </div>
          </div>
          <div>
            <div @click="BackDetailsClick" class="left backTicket">退票</div>
            <div @click="BackTicketShow = false" class="right close">关闭</div>
          </div>
        </div>
      </van-popup>
      <van-popup
        v-model="BackTicketPromptShow"
        position="center"
        :overlay="true"
        class="BackTicketPromptShow"
      >
        <div class="title">提示</div>
        <div class="content">您确定要退票吗？</div>
        <div class="btn">
          <div @click="confirmBackTicketBtnClick" class="left">确定</div>
          <div @click="BackTicketPromptShow = false" class="right">取消</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  components: {
    Header,
  },
  data() {
    return {
      title: "退票管理", //标题
      active: 0, // 选项卡默认显示
      CardInfo: "", //身份证信息
      IdCardNum: null, // 输入的身份证号码
      startBarCode: null, // 开始条码
      searchTicketNum: 1, // 查询的张数
      selectedTicketNum: null, // 选中的票数
      allPayPrice: null, // 实付金额汇总
      allRatio: null, // 手续比例汇总
      allFee: null, // 手续费汇总
      allBackMoney: null, // 应退金额
      searchBarCodeArr: [], // 查询票的条码数组
      resultTicketArr: [], // 根据条件查询已购票的结果
      originResultTicketArr: [], // 根据条件查询已购票的结果(初始化)
      TicketDetailsShow: false, // 车票详情的显示状态
      selectedTicketDetailsArr: [], // 查看该车票详情 包含的数组内容
      screenArr: [], // 被选中的查询结果
      BackTicketShow: false, // 退票弹出层显示状态
      selectedTicketAllPrice: null, // 退票详情 -- 车票总价
      selectedTicketAllNum: null, // 退票详情 -- 车票数量
      selectedTicketAllRatio: null, // 退票详情 -- 退票费率
      selectedTicketAllFee: null, // 退票详情 -- 手续费
      selectedTicketAllBackMoney: null, // 退票详情 -- 应退金额
      BackSearchBarCodeArr: [], // 选择退票查询票的数组
      OriginBackSearchBarCodeArr: [], // 选择退票查询票的数组 初始 --- 退票弹出层使用
      PrintBackSearchBarCodeArr: [], // 选择退票查询票的数组 --- 退票凭证打印的时候使用
      BackTicketPromptShow: false, // 退票前询问框 弹出层
      admininfo: window.localStorage.getItem("adminInfo"),
      isOpenRefundTicketPrint: this.$utils.getSysParams("IsTicketRefundPrint"), // 是否启用退票打印
      AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), // 渠道APPID
      OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      CompName: "", // 该账号公司名
    };
  },
  computed: {
    endBarCode() {
      // 截止条码
      return parseInt(this.startBarCode) + parseInt(this.searchTicketNum) - 1;
    },
  },
  methods: {
    onGetCompName() {
      let params = {
        GID: JSON.parse(window.localStorage.getItem("adminInfo")).CompGID,
      };
      this.$http
        .post(this.$api.getCompInfo, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.CompName = res.data[0].CompFullName;
          }
        });
    },
    // 查询按钮的点击事件
    searchTicket() {
      for (var i = 0; i < this.searchTicketNum; i++) {
        var code = parseInt(JSON.parse(JSON.stringify(this.startBarCode)));
        code += i;
        this.searchBarCodeArr += ",";
        this.searchBarCodeArr += code;
      }
      if (this.searchBarCodeArr.length > 0) {
        this.searchBarCodeArr = this.searchBarCodeArr.substr(1);
      }
      let params = {
        BarCodeList: this.searchBarCodeArr,
        AgentAppID: this.AgentAppID,
      };
      if (this.IdCardNum) {
        params = {
          CustCertNo: this.IdCardNum,
          AgentAppID: this.AgentAppID,
        };
      } else if (this.startBarCode) {
        params = {
          BarCodeList: this.searchBarCodeArr,
          AgentAppID: this.AgentAppID,
        };
      }

      this.$http
        .post(this.$api.BackTicket, this.$qs.stringify(params))
        .then((res) => {
          console.log("查询结果：" + JSON.stringify(res.data));
          this.searchBarCodeArr = [];
          if (res.success) {
            this.resultTicketArr = JSON.parse(JSON.stringify(res.data));
            if (res.data.length > 0) {
              for (let u = 0; u < res.data.length; u++) {
                res.data[u].isSelected = false;
              }

              var sortArr = JSON.parse(JSON.stringify(res.data));

              // 售票在前 日期时间倒序
              var finishSoldArr = []; // 已售数组
              var unSoldArr = []; // 未售数组
              sortArr.forEach((item) => {
                if (item.TicketStatusName == "已售") {
                  finishSoldArr.push(item);
                } else {
                  unSoldArr.push(item);
                }
              });

              // 修改成能被日期初始化的格式
              finishSoldArr.forEach((item) => {
                item.ClassDate = item.ClassDate.split("-").join("/");
                item.ClassTime = item.ClassTime + ":00";
              });
              unSoldArr.forEach((item) => {
                item.ClassDate = item.ClassDate.split("-").join("/");
                item.ClassTime = item.ClassTime + ":00";
              });
              // 日期排序
              finishSoldArr.sort(function (a, b) {
                return new Date(a.ClassDate + " " + a.ClassTime).getTime() <
                  new Date(b.ClassDate + " " + b.ClassTime).getTime()
                  ? 1
                  : -1;
              });
              unSoldArr.sort(function (a, b) {
                return new Date(a.ClassDate + " " + a.ClassTime).getTime() <
                  new Date(b.ClassDate + " " + b.ClassTime).getTime()
                  ? 1
                  : -1;
              });
              // 改回原有返回格式
              finishSoldArr.forEach((item) => {
                item.ClassDate = item.ClassDate.split("/").join("-");
                item.ClassTime = item.ClassTime.substring(0, 5);
              });
              unSoldArr.forEach((item) => {
                item.ClassDate = item.ClassDate.split("/").join("-");
                item.ClassTime = item.ClassTime.substring(0, 5);
              });

              sortArr = finishSoldArr.concat(unSoldArr);

              this.resultTicketArr = sortArr;
            }
            this.resultTicketArr[0].isSelected =
              !this.resultTicketArr[0].isSelected;
          }
        })
        .catch((err) => {
          if (this.startBarCode != "") {
            this.$dialog.alert({
              title: "小提示",
              message: err + "\n没有查询到数据，请查看条码或身份证输入是否有误",
            });
          }
          this.searchBarCodeArr = [];
        });
    },
    // 重置按钮的点击事件
    resetBtnClick() {
      this.startBarCode = null;
      this.selectedTicketNum = null;
      this.allPayPrice = null;
      this.allRatio = null;
      this.allFee = null;
      this.allBackMoney = null;
      this.IdCardNum = null;
    },
    // 查看详情按钮点击事件
    searchDetailsBtnClick(item, index) {
      this.selectedTicketDetailsArr = item;
      this.selectedTicketDetailsArr.setId = index;
      this.TicketDetailsShow = true;
    },
    // 选中状态
    searchResultClick(item, index) {
      for (var i = 0; i < this.resultTicketArr.length; i++) {
        this.resultTicketArr[i].isSelected = false;
        if (i == index) {
          // this.resultTicketArr[i].isSelected = !this.resultTicketArr[i].isSelected;
          this.resultTicketArr[i].isSelected = true;
        }
      }
      // 通过清空 this.resultTicketArr 再赋值来重新渲染 DOM
      const arr = JSON.parse(JSON.stringify(this.resultTicketArr));
      this.resultTicketArr = [];
      this.resultTicketArr = arr;
    },
    // 退票点击事件 -- 主页面的退票按钮
    backTicketBtnClick() {
      let i = 0;
      this.screenArr.forEach((val) => {
        if (val.TicketStatusName == "已售") {
          i++;
        }
      });
      if (this.screenArr.length !== i) {
        this.$toast("选择了不可退票的数据,请重新选择");
      } else {
        // 可以点击退票，先发送查询退票请求
        this.selectedTicketAllPrice = null;
        this.selectedTicketAllFee = null;
        this.selectedTicketAllBackMoney = null;
        for (let i = 0; i < this.screenArr.length; i++) {
          let code = parseInt(
            JSON.parse(JSON.stringify(this.screenArr[i].BarCode))
          );
          this.BackSearchBarCodeArr += ",";
          this.BackSearchBarCodeArr += code;
          this.OriginBackSearchBarCodeArr += ",";
          this.OriginBackSearchBarCodeArr += code;
          this.PrintBackSearchBarCodeArr += ",";
          this.PrintBackSearchBarCodeArr += code;
        }
        if (this.screenArr.length > 0) {
          this.BackSearchBarCodeArr = this.BackSearchBarCodeArr.substr(1);
        }
        if (this.screenArr.length > 0) {
          this.OriginBackSearchBarCodeArr =
            this.OriginBackSearchBarCodeArr.substr(1);
        }
        if (this.screenArr.length > 0) {
          this.PrintBackSearchBarCodeArr =
            this.PrintBackSearchBarCodeArr.substr(1);
        }
        let params = {
          BarCodeList: this.BackSearchBarCodeArr,
          AgentAppID: this.AgentAppID,
        };
        this.$http
          .post(this.$api.BackTicket, this.$qs.stringify(params))
          .then((res) => {
            if (res.success) {
              this.BackTicketShow = true;
              const data = res.data;
              const len = data.length;
              for (let i = 0; i < len; i++) {
                this.selectedTicketAllPrice += data[i].PayPrice;
                this.selectedTicketAllFee += data[i].Fee;
                this.selectedTicketAllBackMoney += data[i].BackMoney;
              }
              this.selectedTicketAllFee = this.selectedTicketAllFee.toFixed(2);
              this.selectedTicketAllBackMoney =
                this.selectedTicketAllBackMoney.toFixed(2);
              this.selectedTicketAllNum = len;
              this.selectedTicketAllRatio = data[0].Ratio; // 查询完后退票费率(手续比例)默认显示 选中的第一个的退票费率
            }
            this.BackSearchBarCodeArr = [];
          })
          .catch((err) => {
            this.$toast(JSON.stringify(err));
            this.BackSearchBarCodeArr = [];
          });
      }
    },
    // 改变退票费率触发事件
    keyupChangeTicketRatio() {
      if (this.selectedTicketAllRatio >= 100) {
        this.selectedTicketAllRatio = 100;
      }
      let params = {
        BarCodeList: this.OriginBackSearchBarCodeArr,
        Ratio: this.selectedTicketAllRatio,
        AgentAppID: this.AgentAppID,
      };
      this.$http
        .post(this.$api.BackTicket, this.$qs.stringify(params))
        .then((res) => {
          if (res.success) {
            this.BackTicketShow = true;
            const data = res.data;
            const len = data.length;
            this.screenArr = res.data;
            this.selectedTicketAllFee = null;
            this.selectedTicketAllBackMoney = null;
            for (let i = 0; i < len; i++) {
              this.selectedTicketAllFee += data[i].Fee;
              this.selectedTicketAllBackMoney += data[i].BackMoney;
            }
            if (this.selectedTicketAllFee != null) {
              this.selectedTicketAllFee = this.selectedTicketAllFee.toFixed(2);
            }
            if (this.selectedTicketAllBackMoney != null) {
              this.selectedTicketAllBackMoney =
                this.selectedTicketAllBackMoney.toFixed(2);
            }
          }
        })
        .catch((err) => {
          this.$toast(err);
          this.BackSearchBarCodeArr = [];
        });
    },
    // 退票详情的退票按钮
    BackDetailsClick() {
      this.BackTicketPromptShow = true;
      // 如果退票费率没输入， 让退票费率等于第一张票的费率
      if (this.selectedTicketAllRatio == "") {
        this.selectedTicketAllRatio = this.screenArr[0].Ratio;
      }
    },
    // 最终确认退票按钮
    confirmBackTicketBtnClick() {
      const _CompGID = JSON.parse(
        window.localStorage.getItem("adminInfo")
      ).CompGID;
      var _jsonText = {};
      _jsonText.AgentAppID = this.AgentAppID;
      _jsonText._CompGID = _CompGID;
      _jsonText.OperGID = this.OperObj.GID; //操作员GID
      _jsonText.OperCode = this.OperObj.UserCode; //操作员代码
      _jsonText.OperName = this.OperObj.UserName; //操作员名称
      var TicketJsonData = [];
      for (var i = 0; i < this.screenArr.length; i++) {
        var item = this.screenArr[i];
        item.Ratio = this.selectedTicketAllRatio;
        TicketJsonData.push(item);
      }
      _jsonText.TicketJsonData = JSON.stringify(TicketJsonData);
      // let params = {
      //   _jsonText: JSON.stringify(_jsonText)
      // };
      this.$http
        .post(this.$api.BackTicketCommit, this.$qs.stringify(_jsonText))
        .then((res) => {
          if (res.success) {
            this.$toast("退票成功");
            this.BackTicketShow = false;
            this.BackTicketPromptShow = false;
            this.searchTicket();
            if (this.isOpenRefundTicketPrint == 1) {
              // 为1 启用退票打印
              this.$toast("启用退票打印");
              // 调用退票打印的ajax
              let params = {
                BarcodeList: this.PrintBackSearchBarCodeArr,
              };
              this.$http
                .post(
                  this.$api.TicketDetailBackPrintQuery,
                  this.$qs.stringify(params)
                )
                .then((res) => {
                  if (res.success) {
                    this.PrintBackSearchBarCodeArr = [];
                    let data = res.data;
                    setTimeout(() => {
                      if (data.length < 1) {
                        this.$toast("未获取到数据");
                      } else {
                        this.$toast("请稍等，正在准备打印");
                      }
                      this.onPrintTicket(data);
                    }, 1200);
                  }
                })
                .catch((err) => {
                  this.$dialog.alert({
                    title: "提示",
                    message: err,
                  });
                  this.PrintBackSearchBarCodeArr = [];
                });
            }
          }
        })
        .catch((err) => {
          this.$dialog.alert({
            title: "提示",
            message: err,
          });
        });
    },
    //打印票据
    onPrintTicket(obj) {
      if (!window.framework) {
        this.$toast.fail("请在手持机上开启打印功能");
        return;
      }
      // JSON 格式数据
      var jsonArray = [];
      for (let i = 0; i < obj.length; i++) {
        jsonArray.push(
          {
            type: 1,
            size: 2,
            data: "" + obj[i].PrintTitleName + "",
          },
          {
            type: 1,
            data: "           (定制巴士)\n",
          },
          {
            type: 1,
            size: 2,
            data:
              "" + obj[i].StartNodeName + "—" + obj[i].ArrivalNodeName + "\n",
          },
          {
            type: 1,
            data:
              "票      号：" +
              obj[i].BarCode +
              "\n发车  时间：" +
              obj[i].ClassDate.split(" ")[0] +
              " " +
              obj[i].ClassTime +
              "\n座      位：" +
              obj[i].SeatNo +
              "号\n票      价：" +
              obj[i].PayPrice +
              "元\n退票手续费：" +
              obj[i].Fee +
              "元\n退票  金额：" +
              obj[i].BackMoney +
              "元\n退  票  人：" +
              obj[i].CustName +
              "\n",
          },
          {
            type: 3,
            data: "" + obj[i].TicketInvoiceAddress + "",
          },
          {
            type: 1,
            data: "\n扫描二维码即可申请退票手续费发票，发票将会在3至5个工作日发送到邮箱",
          },
          {
            type: 1,
            data: "\n\n",
          }
        );
      }
      if (window.framework.jsPrintJsonData) {
        window.framework.jsPrintJsonData(JSON.stringify(jsonArray));
      } else {
        this.$toast("该手持机不支持的打印方法");
      }
    },
    // 放置证件获取乘客购票记录
    readInfo() {
      if (window.framework) {
        // 打开扫描
        if (window.framework.isReadScanner) {
          window.framework.isReadScanner(true);
        }

        //开启NFC模块
        if (window.framework.isReadCard) {
          window.framework.isReadCard(true);
        }

        var fun = function (jsonObj) {
          //读取失败
          if (!jsonObj.success) {
            this.$toast.fail("身份证读取失败！");
            return;
          }
          this.CardInfo = jsonObj.data;
          this.IdCardNum = this.CardInfo["身份号码"];
          if (this.IdCardNum != "") {
            this.searchTicket();
          }
          this.active = 1;
        };
        var nfcFun = function (ReqId, AndroidID) {
          //读取失败
          if (!ReqId) {
            this.$toast.fail("身份证读取失败！");
            return;
          }
          //调动后端接口获取身份信息
          this.$http
            .post(
              this.$api.getIdCardCloudDecode,
              this.$qs.stringify({ ReqId: ReqId, AndroidID: AndroidID })
            )
            .then((res) => {
              if (res.success) {
                //alert('获取身份证信息成功')
                //alert(JSON.stringify(res.data))
                //将身份信息转为CardInfo对象
                let jsonObj = {
                  success: res.success,
                  data: {
                    姓名: res.data.Name,
                    身份号码: res.data.IdNum,
                    //照片: res.data.Picture
                  },
                };
                fun.bind(this)(jsonObj);
              }
            });
        };
        //NFC读取身份证
        window.callJSIdCardCloudDecode = nfcFun.bind(this);
        //读取身份证回调
        window.callJSPersonInfo = fun.bind(this);

        //扫码枪回调
        var JsscanBack = function (code) {
          //扫码失败
          if (code == "" || code == null || code.length == 0) {
            this.$toast.fail("扫码失败！");
            return;
          } else {
            this.startBarCode = code;
            this.active = 1;
          }
        };
        window.callJSScan = JsscanBack.bind(this);
      }
    },
  },
  mounted() {
    this.readInfo();
    this.onGetCompName();

    if (this.$route.query.BarCode) {
      this.active = 1;
      this.startBarCode = this.$route.query.BarCode;
      console.log("进入页面BarCode:" + this.startBarCode);
      this.searchTicket();
    }

    if (window.framework) {
      // 连接打印机
      if (window.framework.isReadPrint && this.isOpenRefundTicketPrint == 1) {
        window.framework.isReadPrint(true);
      }
    }
  },
  watch: {
    // 限制票的张数 --- 必须大于等于 1
    searchTicketNum(val) {
      if (val < 1) {
        this.searchTicketNum = 1;
        this.$toast("查询张数不能小于1");
      }
    },
    // 选中的票改变时
    resultTicketArr(arr) {
      const screenArr = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].isSelected) {
          screenArr.push(arr[i]);
        }
      }
      this.allPayPrice = null;
      this.allRatio = null;
      this.allFee = null;
      this.allBackMoney = null;
      this.selectedTicketNum = screenArr.length;
      for (let i = 0; i < screenArr.length; i++) {
        this.allPayPrice += screenArr[i].PayPrice;
        this.allRatio += screenArr[i].Ratio;
        this.allFee += screenArr[i].Fee;
        this.allBackMoney += screenArr[i].BackMoney;
      }
      if (this.allFee != null) {
        this.allFee = this.allFee.toFixed(2);
      }
      if (this.allBackMoney != null) {
        this.allBackMoney = this.allBackMoney.toFixed(2);
      }
      this.screenArr = screenArr;
    },
    // 监听 退票弹出层
    BackTicketShow(val) {
      if (val == false) {
        // 在退票弹出层消失时 将 OriginBackSearchBarCodeArr 和 PrintBackSearchBarCodeArr 清为空数组
        this.OriginBackSearchBarCodeArr = [];
        this.PrintBackSearchBarCodeArr = [];
      }
    },
    // 身份证号
    IdCardNum(val) {
      if (val.length > 0) {
        this.startBarCode = "";
      }
    },
    startBarCode(val) {
      if (val.length > 0) {
        this.IdCardNum = "";
      }
    },
  },
  created() {},
  destroyed() {
    this.CardInfo = null;
    if (window.framework) {
      if (window.framework.isReadCard) {
        window.framework.isReadCard(false);
      }
      // 断开打印机
      if (window.framework.isReadPrint) {
        window.framework.isReadPrint(false);
      }
      if (window.framework.isReadScanner) {
        //关闭扫描头
        window.framework.isReadScanner(false);
      }
    }
  },
};
</script>

<style scoped lang="less">
[v-cloak] {
  display: none !important;
}

.RefundTicket /deep/ .van-tabs {
  z-index: 0;
}

.RefundTicket {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 0.4rem;
  > .header {
    font-size: 0.5rem;
    text-align: center;
    padding: 0.2rem 0;
    background-color: #eee;
  }
  .checkCar {
    width: 100%;
    height: 6.4rem;
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
    p:first-child {
      font-size: 0.5rem;
      margin-top: 1rem;
    }
    p:nth-child(2) {
      font-size: 0.5rem;
      margin-top: 1.2rem;
      color: #ffb870;
    }
    p:last-child {
      font-size: 0.5rem;
      margin-top: 1.2rem;
    }
  }
  .wrap {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-color: #fff;
    padding: 0.4rem 0;
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
    > label {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      display: flex;
      justify-content: space-between;
      margin-top: 0.4rem;
      font-size: 0.44rem;
      padding: 0 0.4rem;
      box-sizing: border-box;
      > span {
        flex: 1;
        text-align: left;
      }
      > input {
        width: 4.4rem;
        height: 0.8rem;
        line-height: 0.8rem;
        border: 1px solid #ccc;
        padding: 0.08rem 0.08rem 0.08rem 0.12rem;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }
    }
    > label:first-child {
      margin-top: 0;
    }
    > label:nth-child(2) {
      position: relative;
      .add,
      .reduce {
        width: 0.6rem;
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #eee;
        position: absolute;
        top: 0.1rem;
        right: 2rem;
        font-size: 0.5rem;
      }
      .reduce {
        right: 0.8rem;
      }
    }
    > .header {
      font-size: 0.5rem;
      background-color: #eee;
      padding: 0.2rem 0;
    }
    > .endBarCode {
      color: #ccc;
    }
    > .btn {
      width: 100%;
      height: auto;
      display: flex;
      justify-content: space-between;
      margin-top: 0.4rem;
      box-sizing: border-box;
      padding: 0 2rem;
      > .search,
      .reset {
        width: 2rem;
        height: 0.8rem;
        line-height: 0.8rem;
        border-radius: 0.08rem;
        background-color: rgba(31, 189, 16, 0.733);
        color: #fff;
      }
      > .reset {
        background-color: #f8813c;
      }
    }
    .backTicketBtn {
      width: 2.5rem;
      height: auto;
      color: #fff;
      padding: 0.2rem 0;
      font-size: 0.4rem;
      background-color: #2891e7;
      margin-top: 0.4rem;
    }
    .ticketDetails {
      display: flex;
      justify-content: space-between;
      font-size: 0.44rem;
      padding: 0.2rem 0.4rem;
      box-sizing: border-box;
    }
    .searchDetails {
      text-align: right;
      color: #f8813c;
      padding-right: 0.4rem;
      box-sizing: border-box;
      .icon {
        font-size: 0.4rem;
      }
    }
  }
  .searchResult {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    overflow: hidden;
    > .wrap {
      width: 100%;
      height: 100%;
      overflow: hidden;
      padding: 0.4rem 0;
      box-sizing: border-box;
      > .header {
        font-size: 0.5rem;
        background-color: #eee;
        padding: 0.2rem 0;
      }
      .ticketDetails {
        display: flex;
        justify-content: space-between;
        font-size: 0.44rem;
        padding: 0.2rem 0.4rem;
        box-sizing: border-box;
      }
      .searchDetails {
        text-align: right;
        color: #f8813c;
        padding-right: 0.4rem;
        box-sizing: border-box;
        .icon {
          font-size: 0.4rem;
        }
      }
    }
    .searchResultCurrent {
      background-color: #ffb870;
      color: #fff;
    }
  }
  .notData {
    margin: 0.4rem 0;
  }
  > .wrap:nth-child(3) {
    padding-top: 0;
  }
  > .wrap:last-child {
    border: none;
  }
  .TicketDetailsShow {
    width: 80%;
    height: auto;
    > div {
      width: 100%;
      height: 14rem;
      box-sizing: border-box;
      overflow-y: scroll;
      background-color: #fff;
      position: relative;
      > div {
        width: 100%;
        height: 1rem;
        line-height: 1rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        padding: 0 0.4rem;
        .left {
          flex: 1;
          text-align: left;
        }
        .right {
          width: 4rem;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: right;
        }
      }
    }
  }
  .BackTicketShow {
    width: 80%;
    height: auto;
    font-size: 0.4rem;
    border-radius: 0.2rem;
    > .header {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      background-color: #ffb870;
      padding: 0.2rem 0;
      color: #fff;
      font-size: 0.5rem;
    }
    > .container {
      width: 100%;
      height: auto;
      box-sizing: border-box;
      overflow-y: scroll;
      background-color: #fff;
      > div {
        width: 100%;
        height: 1.4rem;
        line-height: 1.4rem;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        box-sizing: border-box;
        padding: 0 0.4rem;
        > .left {
          width: 40%;
          text-align: left;
        }
        > .right {
          width: 60%;
          box-sizing: border-box;
          > input {
            width: 100%;
            height: 1rem;
            line-height: 1rem;
            overflow: hidden;
            padding-left: 0.4rem;
            box-sizing: border-box;
            border: 1px solid #ccc;
          }
        }
        .backTicket,
        .close {
          width: 45%;
          height: 1rem;
          line-height: 1rem;
          margin-top: 0.2rem;
          text-align: center;
          background-color: #2891e7;
          color: #fff;
        }
        .close {
          background-color: red;
        }
      }
    }
  }
  .BackTicketPromptShow {
    width: 60%;
    height: auto;
    font-size: 0.4rem;
    text-align: center;
    border-radius: 0.2rem;
    > .title {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      background-color: #ffb870;
      padding: 0.2rem 0;
      color: #fff;
      font-size: 0.5rem;
    }
    > .content {
      width: 100%;
      height: 2rem;
      line-height: 2rem;
    }
    > .btn {
      display: flex;
      justify-content: space-around;
      .left,
      .right {
        width: 40%;
        height: 1rem;
        line-height: 1rem;
        margin-top: 0.2rem;
        text-align: center;
        background-color: #2891e7;
        color: #fff;
        border-radius: 0.1rem;
        margin-bottom: 0.2rem;
      }
      .right {
        background-color: red;
      }
    }
  }
}
</style>
